/* biome-ignore-all lint/suspicious/noExplicitAny: dynamic log data structure */
import { HttpRequest } from "@/utils/request"
import { API_URL, VERSION_API } from "@/configs/config"

import type { PageQueryParams } from "@/types/global.d"

export interface SystemLogServiceItem {
  id: string
  name: string
  description: string
  type: string
  available: boolean
  enabled: boolean
}

export interface SystemLogFileItem {
  name: string
  size: number
  mtime: string
  is_current: boolean
  target?: string | null
}

export interface SystemLogError {
  type?: string
  message?: string
  stack?: string
  name?: string
  statusCode?: number
}

export interface SystemLogRequest {
  method?: string
  url?: string
  headers?: Record<string, any>
  remoteAddress?: string
}

export interface SystemLogResponse {
  statusCode?: number
  responseTime?: number
}

export interface SystemLogItem {
  _id: string
  lineIndex: number
  level: number
  time: string | null
  msg: string
  statusCode?: number
  err?: SystemLogError | null
  req?: SystemLogRequest | null
  res?: SystemLogResponse | null
  raw?: string
  [key: string]: any
}

export interface SystemLogStats {
  total: number
  error: number
  warn: number
  info: number
  debug: number
}

export interface SystemLogQueryParams extends Partial<PageQueryParams> {
  file?: string
  level?: string
  status_code?: string
  search?: string
  page?: number
  limit?: number
  per_page?: number
}

export interface SystemLogListResponse {
  code: number
  data: SystemLogItem[]
  total: number
  page: number
  limit: number
  file: string
  stats: SystemLogStats
}

export const systemLogService = {
  getServices() {
    return HttpRequest.get("v1/logs/services").json<{
      code: number
      data: SystemLogServiceItem[]
    }>()
  },

  getFiles(service: string) {
    return HttpRequest.get(`v1/logs/${service}/files`).json<{
      code: number
      data: SystemLogFileItem[]
      message?: string
    }>()
  },

  list(service: string, params: SystemLogQueryParams) {
    return HttpRequest.get(`v1/logs/${service}`, {
      searchParams: params as any,
    }).json<SystemLogListResponse>()
  },

  getDownloadUrl(service: string, file: string) {
    const cleanApi = API_URL.replace(/\/+$/, "")
    return `${cleanApi}/${VERSION_API}/logs/${service}/download?file=${encodeURIComponent(file)}`
  },
}
